import React, { useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import DialogOTP from '../components/Complements/DialogOTP';
import UsernameChangeFormReduxForm from '../components/UsernameChange/UsernameChangeForm';
import { feathersCreateData } from '../services';
import { encrypt } from '../functions/mobile';
import { history } from '../helpers/history';
import { changeStatusFlagUsernameChange } from '../actions/loginUser';
import { filterArrayEqual } from '../functions/arrays';
import Title from './../components/Complements/Title';
import { passwordProgressControl } from '../functions/validators';
import { findValidators } from './../actions/validators';

const UsernameChangeContainer = props => {
    const { parameters, devices, handleOpenSnack } = props;

    const [openDialogOtp, setOpenDialogOtp] = useState(false);
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [validators, setValidators] = useState([]);
    const [otpError, setOtpError] = useState(false);

    const otpInitialTimeRef = useRef(Date.now()); // Para que el tiempo no se reinicie
        const [dataValidation, setdataValidation] = useState({
        numberValid: false,
        characterValid: false,
        identificationValid: false,
        charNumberValid: false,
        progress: 0
    })
    const handleGenerateOtp = async (values) => {
        try {
            setUsername(values.username);
            handleProccesGenerateOtp();
        } catch (error) {
            setLoading(false);
            handleOpenSnack("Ha ocurrido un error al generar el código", "error");
        }
    };

    const handleProccesGenerateOtp = async () => {
        try {
            setLoading(true);
            const { ip, device, mac } = devices;
            const sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE', type: 33, deviceData: device, ip, mac
            }));
            await feathersCreateData('codes-recovery', { sendData })();
            setOpenDialogOtp(true);
            otpInitialTimeRef.current = Date.now(); // reinicia tiempo solo cuando se genera un OTP nuevo
            setLoading(false);
        } catch (error) {
            setLoading(false);
            handleOpenSnack("Ha ocurrido un error al generar el código", "error");
        }
    };

    const handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN');
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 6;
        if (valueinput.target.value.toString().length === tokenLength) {
            handleOTPCompare({ data: valueinput.target.value.toString() });
        }
    };

   const handleValidationUsername = (value) => {

        try {

            // const numberOfCharactersObj = filterArrayEqual(parameters, 'code', 'NUMBER_OF_CHARACTERS_VALIDATION_CHANGE_OF_USERNAME')
            // const numberOfCharacters = (timeLifeTokenObj.length > 0) ? Number(numberOfCharactersObj[0].value) : 10

            // const numberValid = (value) ? checkNumber(value) : false
            // const characterValid = (value) ? checkLetters(value) : false
            // const identificationValid = (value) ? (value.toString().indexOf(auth.vusk) === 0) ? false : true : false
            // const charNumberValid = (value) ? checkPasswordLength(value, numberOfCharacters) : false

            // //console.log("Color: ", passwordProgressControl({numberValid, characterValid, identificationValid, charNumberValid }, 4))

            // setdataValidation({
            //     numberValid,
            //     characterValid,
            //     identificationValid,
            //     charNumberValid,
            //     progress: passwordProgressControl({numberValid, characterValid, identificationValid, charNumberValid }, 4)
            // })

            props.findValidators("validators", {
                query: {
                    type: {
                        $in: [39]
                    },
                    state: {
                        $in: [1]
                    }
                }
            }).then(res => {
                const { data } = res.payload
                data.map(row => {
                    row.validationState = false
                    return null
                })
                let temporalValidator = data

                for (let i = 0; i < data.length; i++) {
                    try {
                        temporalValidator[i].validationState = value.match(data[i].expression) ? true : false
                    } catch (error) {
                    }
                    setValidators(temporalValidator)
                }

                // this.setState({passwordNew : value, progress: passwordProgressControl(temporalValidator , this.state.validators.length) })
                setdataValidation({

                    progress: passwordProgressControl(temporalValidator, validators.length)
                })

            }).catch(error => {
                // console.log(error)
            })

        } catch (error) {
            //console.log(error)
        }
    }


    const handleOTPCompare = async ({ data }) => {
        try {
            setLoading(true);
            const { ip, device, mac } = devices;
            const sendData = encrypt(JSON.stringify({ ip, mac, device, type: 33, inputOtp: data }));
            const responseValidateCode = await feathersCreateData("code-validation", { sendData })();
            const { error, message, viewDialogOtp } = responseValidateCode;

            if (!error) {
                const responseUsernameChange = await feathersCreateData("procces-username-change", {
                    ip, mac, device, otp: data, username
                })();

                if (responseUsernameChange.status) {
                    props.changeStatusFlagUsernameChange(0);
                    history.push('/');
                    handleOpenSnack(responseUsernameChange.message, "success");
                } else {
                    handleOpenSnack(responseUsernameChange.message, "error");
                }
                setOpenDialogOtp(false);
            } else {
                // No cerramos el dialog, solo marcamos error
                setOtpError(true);
                handleOpenSnack(message, "error");
            }
        } catch (error) {
            handleOpenSnack("Ha ocurrido un error al validar el OTP.", "error");
        } finally {
            setLoading(false);
        }
    };

    const renderBody = () => (
        <div>
            <Title>Cambio de Nombre de Usuario</Title>
            <UsernameChangeFormReduxForm
                onSubmit={handleGenerateOtp}
                progress={dataValidation.progress}
                validators={validators}
                handleValidationUsername={handleValidationUsername}
            />
        </div>
    );

    const timeLifeTokenObj = filterArrayEqual(parameters, 'code', 'TIME_LIFE_TOKEN');
    const timeLifeToken = (timeLifeTokenObj.length > 0) ? Number(timeLifeTokenObj[0].value) : 180000;

    return (
        <div>
            <LoadingScreen open={loading} />
            <Dashboard title="" body={renderBody()} multiple={false} />
            <DialogOTP
                openDialogOTP={openDialogOtp}
                onCloseDialogOTP={() => setOpenDialogOtp(false)}
                initialTime={otpInitialTimeRef.current}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPCompare}
                onKeyPress={handleChangeInputOtp}
                timeLifeToken={timeLifeToken}
                refreshToken={handleProccesGenerateOtp}
                otpError={otpError} // opcional
            />
        </div>
    );
};

export default withRouter(connect(null, { changeStatusFlagUsernameChange, findValidators })(UsernameChangeContainer));
